import Popover from "@storeblocks/popover";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { useUserIdentificationSelector } from "Store/userIdentification/userIdentificationSelectors";
import { isDefined } from "Utils/functions";
import React from "react";
import { UserAddress } from "./UserAddress";
import { UserDateOfBirth } from "./UserDateOfBirth";
import { UserName } from "./UserName";
import { WrongInfo } from "./WrongInfo";
import { useCustomerAddress } from "./hooks";
import { SignedInUserPopoverContent, Wrapper } from "./styled";

interface Props {
  productBackendName?: ProductBackendName;
  featureToggleCustomerAddress?: boolean;
}

export const SignedInUser = ({
  productBackendName,
  featureToggleCustomerAddress = false,
}: Props): React.ReactElement | null => {
  const authorizedUser = useUserIdentificationSelector();
  const customerAddress = useCustomerAddress(
    featureToggleCustomerAddress,
    productBackendName,
  );

  const customer = authorizedUser?.newCustomerResponse;
  const isNameDefined = isDefined(customer?.providedPersonInfo?.name);
  const isDateOfBirthDefined = isDefined(customer?.dateOfBirth);
  const isAddressDefined = isDefined(customerAddress);

  if (
    !isDefined(authorizedUser) ||
    !isDefined(authorizedUser.newCustomerResponse) ||
    (!isNameDefined && !isDateOfBirthDefined && !isAddressDefined)
  ) {
    return null;
  }

  return (
    <div className="data-hj-suppress">
      <Wrapper>
        <UserName newCustomerResponse={authorizedUser.newCustomerResponse} />
        <Popover className="signed-in-user-extra-info">
          <SignedInUserPopoverContent>
            <UserDateOfBirth
              newCustomerResponse={authorizedUser.newCustomerResponse}
            />
            {featureToggleCustomerAddress &&
              productBackendName === ProductBackendName.ADVICE && (
                <UserAddress customerAddress={customerAddress} />
              )}
            {featureToggleCustomerAddress && isAddressDefined && <WrongInfo />}
          </SignedInUserPopoverContent>
        </Popover>
      </Wrapper>
    </div>
  );
};
